export class CuttingCadModelMaterialLink {
  originalMaterialFullName: string;
  materialThickness: number;
  materialType: CadModelMaterialType;

  linkedMaterialName: string;
  linkedMaterialArticle: string;
  linkedMaterialId: number;
  linkedGroupMaterialId: number;
  linkedMaterialThickness: number;
  linkedMaterialType: CadModelMaterialType;

  height = 0;
  width = 0;

  // butt params
  linkedButtSign: string;
  linkedButtOverhung: number;
  linkedButtAllowance: number;
  linkedButtWidth: number;

  constructor(link?: CuttingCadModelMaterialLink | any) {
    link = link || {};
    this.originalMaterialFullName = link.originalMaterialFullName || '';
    this.materialThickness = link.materialThickness || 0;
    this.materialType = link.materialType || 0;
    this.linkedMaterialName = link.linkedMaterialName || '';
    this.linkedMaterialArticle = link.linkedMaterialArticle || '';
    this.linkedMaterialId = link.linkedMaterialId || undefined;
    this.linkedGroupMaterialId = link.linkedGroupMaterialId || undefined;
    this.linkedMaterialThickness = link.linkedMaterialThickness || 0;
    this.linkedMaterialType = link.linkedMaterialType || 0;

    this.height = link.height || 0;
    this.width = link.width || 0;

    this.linkedButtSign = link.linkedButtSign || '';
    this.linkedButtOverhung = link.linkedButtOverhung || 0;
    this.linkedButtAllowance = link.linkedButtAllowance || 0;
    this.linkedButtWidth = link.linkedButtWidth || 0;
  }
}

export enum CadModelMaterialType {
  Plate,
  Linear,
  Side,
  Slot,
  Fastener,
  Assembly,
}
